import { useMutation } from "@tanstack/react-query";
import { createData } from "@/lib/services/data-layer";
import { url } from "@/lib/services/data-layer/core";
import { sendOtpProps, sendOtpResponse } from "@/lib/types/DTO/core/auth";

const sendOtp = async ({ mobile }: sendOtpProps): Promise<sendOtpResponse> => {
  await createData(url + "auth/otp", { mobile });

  return true;
};

export const useSendOtpMutation = () => {
  return useMutation({
    mutationFn: sendOtp,
  });
};
